import React from 'react';
import { 
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  styled
} from '@mui/material';
import { 
  HashRouter as Router, 
  Route, 
  NavLink,
  Switch,
  useLocation
} from 'react-router-dom';
import SignInForm from '../../containers/Login/SignInForm';
import SignUpForm from '../../containers/Login/SignUpForm';

const AuthLayoutContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.mode === 'dark' 
    ? 'radial-gradient(circle at center, #1a1a2e 0%, #16213e 100%)' 
    : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  padding: theme.spacing(2)
}));

const AuthCard = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 500,
  padding: theme.spacing(4),
  borderRadius: 12,
  boxShadow: theme.shadows[10],
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3)
  }
}));

const AuthTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '& .MuiTabs-indicator': {
    height: 4,
    borderRadius: '2px 2px 0 0'
  }
}));

const AuthTab = styled(Tab)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  padding: theme.spacing(1.5, 2),
  minHeight: 'auto'
}));

const AuthLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  const getTabValue = () => {
    if (location.pathname.includes('/sign-up')) return 1;
    return 0; // Default to sign-in
  };

  return (
    <AuthLayoutContainer>
      <Container maxWidth="sm">
        <AuthCard elevation={3}>
          <AuthTabs 
            value={getTabValue()}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
          >
            <AuthTab 
              label="Sign In" 
              component={NavLink} 
              to="/sign-in" 
            />
            <AuthTab 
              label="Sign Up" 
              component={NavLink} 
              to="/sign-up" 
            />
          </AuthTabs>

          <Switch>
            <Route path="/sign-in" component={SignInForm} />
            <Route path="/sign-up" component={SignUpForm} />
            <Route path="/" component={SignInForm} /> {/* Default to sign-in */}
          </Switch>
        </AuthCard>
      </Container>
    </AuthLayoutContainer>
  );
};

export default AuthLayout;